import {
  Injectable,
  EventEmitter
} from '@angular/core';
import {
  Map
} from 'leaflet';
import * as L from 'leaflet';
import 'leaflet';
import 'leaflet.markercluster';
import Marker = L.Marker;
import Icon = L.Icon;
import LatLngExpression = L.LatLngExpression;
import FeatureGroup = L.FeatureGroup;
import Polygon = L.Polygon;
import Polyline = L.Polyline;
import CircleMarker = L.CircleMarker;
import Circle = L.Circle;

import {
  RtMarker,
  newRtMarker
} from "./marker";
import {
  GlobalService
} from "../providers/global.config";
import {
  Events
} from 'ionic-angular/util/events';

@Injectable()
export class MapService {

  public map: Map;
  public baseMaps: any;

  public drawnItems: FeatureGroup;

  public mapLoaded: EventEmitter < boolean > = new EventEmitter < boolean > ();

  public markerWasAdded: EventEmitter < any > = new EventEmitter < any > ();
  public markerWasEdited: EventEmitter < any > = new EventEmitter < any > ();

  public polygons: Polygon[] = [];
  public markers: Marker[] = [];
  public polylines: Polyline[] = [];
  public circles: Circle[] = [];
  public newRtMarkers: newRtMarker[] = [];
  public rtMarkers: RtMarker[] = [];

  public markersPoi: Marker[] = [];
  public polygonsPoi: Polygon[] = [];
  markercluster = L.markerClusterGroup();
  imagesDir = this.globalService.getimagesDir();
  constructor(/*public events: Events*/private globalService : GlobalService) {
    this.baseMaps = {

      Fleet: L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
        maxZoom: 20,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),

    /*  googlestreet: L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
        id: 'Google Streets',
        maxZoom: 20,
        maxNativeZoom: 17,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
      }),*/
      
                  googlehybride: L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}', {
                      maxZoom: 20,
                      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                  }),
                  googleSat: L.tileLayer('http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                      maxZoom: 20,
                      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                  }),
                  'Google Terrain': L.tileLayer('http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}', {
                      maxZoom: 20,
                      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
                  }),
                  
                  OpenStreetMap: L.tileLayer("http://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png", {
                      maxZoom: 20,
                      maxNativeZoom: 17,
                      attribution: '&copy; <a href="rimtelecom.ma">Rim telecom</a>, Tiles courtesy of <a href="http://hot.openstreetmap.org/" target="_blank">Humanitarian OpenStreetMap Team</a>'
                  }),
                  Esri: L.tileLayer("http://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}", {
                      attribution: 'Rimtelecom'
                  }),
                  CartoDB: L.tileLayer("http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png", {
                      maxZoom: 20,
                      maxNativeZoom: 17,
                      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="http://cartodb.com/attributions">CartoDB</a>'
                  }),
                  Esri_WorldImagery: L.tileLayer('http://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
                      maxZoom: 20,
                      maxNativeZoom: 17,
                      attribution: 'Rimtelecom'
                  })
    };
  }

  addRtMarker(rtMarker: RtMarker) {
    rtMarker.value.setIcon(rtMarker.icon);
    this.rtMarkers.push(rtMarker);
    rtMarker.value.addTo(this.map);
  }

/*
  updateRtMarkertest(coordinate: any, popup: any, icon: any, id: any, isCurrentPathClicked: boolean) {
    //tester si la liste est vide
    //si oui 
    let marker = L.marker(L.latLng(coordinate.lat, coordinate.lng));
    marker.bindPopup(popup);
    marker.on('click', () => {
      this.events.publish('ShowOption', true)
    })
  
    if (this.newRtMarkers == null || this.newRtMarkers.length == 0) {
      marker.addTo(this.map);
      marker.setIcon(icon);
     
      marker.on('click', () => {
        this.map.setView(coordinate, 12);
      });
      this.newRtMarkers.push({
        id: id,
        marker: marker
      });
      
    } else {
      this.newRtMarkers.map(rt => {
        if (rt.id == id) {
          //rt.marker.remove();
          this.newRtMarkers.splice(this.newRtMarkers.indexOf(rt), 1);
          rt.marker.setLatLng(coordinate);
          rt.marker.setIcon(icon);
          rt.marker.getPopup().setContent(popup);
          if (isCurrentPathClicked == true) {
            let marker = L.marker(L.latLng(coordinate.lat, coordinate.lng));
            marker.setIcon(new Icon({
              iconUrl: imagesDir + "green-point.png",
              iconAnchor: [2, 2]
            }));
            this.addMarker(marker);
            let points = [];
            points.push(rt.marker.getLatLng())
            points.push(coordinate.value.getLatLng());
            let polyline = L.polyline(points, {
              color: '#0031D9',
              weight: 3
            });
            this.addPolyline(polyline);
          }
        }
      });
    }

  }
*/
   initCluster(){
        this.markercluster = L.markerClusterGroup({
          //showCoverageOnHover: true,
          zoomToBoundsOnClick: false,
          //spiderfyOnMaxZoom: true,
          removeOutsideVisibleBounds: false,
          //animate: true,
          //animateAddingMarkers: false,
          //disableClusteringAtZoom: 17,
    //maxClusterRadius: 40,
    //polygonOptions: polylineOptions,
    singleMarkerMode: true,
    //spiderLegPolylineOptions: polylineOptions,
    //spiderfyDistanceMultiplier: 1,
    //spiderfyOnMaxZoom: false,
    //spiderfyOnMaxZoom : false,
    //showCoverageOnHover: false,
    //zoomToBoundsOnClick: false,
    chunkedLoading: true,
    //chunkDelay: 110,
        });

    }


  updateRtMarker(rtMarker: RtMarker, isCurrentPathClicked: boolean) {
    let ok: boolean = false;
    this.rtMarkers.map(rt => {
      if (rt.id == rtMarker.id) {
        if (isCurrentPathClicked == true) {

          //console.log("isCurrentPathClicked == true")
          let marker = new Marker(rt.value.getLatLng());
          marker.setIcon(new Icon({
            iconUrl: this.imagesDir + "green-point.png",
            iconAnchor: [2, 2]
          }));
          marker.on('click', () => {
              this.map.setView(rt.value.getLatLng(), this.map.getZoom());
          });
          //this.addMarker(marker);
          this.markers.push(marker);
          this.markercluster.addLayer(marker);
          let points = [];
          points.push(rt.value.getLatLng())
          points.push(rtMarker.value.getLatLng());
          let polyline = L.polyline(points, {
            color: '#0031D9',
            weight: 3
          });
          this.addPolyline(polyline);
        }
        //console.log("isCurrentPathClicked != true")
        rt.value.setLatLng(rtMarker.value.getLatLng());
        //console.log(rtMarker.value.getLatLng());
        rt.value.getPopup().setContent(rtMarker.value.getPopup().getContent());
           rt.value.on('click', () => {
          
          
            this.map.setView(rtMarker.value.getLatLng(), this.map.getZoom());
        });
        
        rt.value.options.rotationAngle = rtMarker.angle;
        rt.value.setIcon(rtMarker.icon);
        ok = true;

      }
    });
    if (!ok) {

    if (rtMarker.value._latlng.lat != 0 && rtMarker.value._latlng.lng != 0)
    {
      this.rtMarkers.push(rtMarker);
      rtMarker.value.setIcon(rtMarker.icon);
  /*this.markercluster.addLayer(rtMarker.value);
 //this.markercluster.refreshClusters();
 this.map.addLayer(this.markercluster);
 this.markercluster.refreshClusters();*/
 rtMarker.value.addTo(this.map);
    }
  



      
     
     //console.log(rtMarker.value._latlng);
      //rtMarker.value.addTo(this.map);
    }
   
  }

  removeAllRtMarkers() {
    this.newRtMarkers.forEach(m => {
      this.map.removeLayer(m.marker);
    });
    this.newRtMarkers = [];
  }

  removeAllRtMarkerstest() {
   /* this.newRtMarkers.forEach(m => {
      this.map.removeLayer(m.marker);
    });*/

    if(this.rtMarkers != []){
     this.rtMarkers.forEach(m => {
      this.map.removeLayer(m.value);
    });
      console.log(this.rtMarkers);
      this.rtMarkers = [];
    }
   
    
  }

 

  addCircle(circle: Circle) {
    this.circles.push(circle);
    circle.addTo(this.map);
  }

  removeCirclesFromMap() {
    this.circles.forEach(m => {
      this.map.removeLayer(m);
    });
    this.circles = [];
  }

  addMarker(marker: Marker) {
    this.markers.push(marker);
    marker.addTo(this.map);
  }

  addMarkerPoi(marker: Marker) {
    this.markersPoi.push(marker);
    marker.addTo(this.map);
  }

  removeMarkersPoiFromMap() {
    this.markersPoi.forEach(m => {
      this.map.removeLayer(m);
    });
    this.markersPoi = [];
  }

  removeMarker(index: number) {
    this.map.removeLayer(this.markers[index]);
    delete this.markers[index];
  }

  addMarkersToMap() {
    this.markers.forEach(marker => {
      marker.addTo(this.map);
    })
  }

  removeMarkersFromMap() {
    
    if(this.markers != []){
     this.markers.forEach(m => {
      this.map.removeLayer(m);
    });
      console.log(this.markers);
      this.markers = [];
    }



  }

  addPolyline(polyline: Polyline) {
    this.polylines.push(polyline);
    polyline.addTo(this.map);
  }

  removePolylinesFromMap() {
    this.polylines.forEach(m => {
      this.map.removeLayer(m);
    });
    this.polylines = [];
  }

  addPolygon(polygon: Polygon) {
    this.polygons.push(polygon);
    polygon.addTo(this.map);
  }

  addPolygonPoi(polygon: Polygon) {
    this.polygonsPoi.push(polygon);
    polygon.addTo(this.map);
  }



  removePolygon(index: number) {
    //this.map.removeLayer(this.polygons[index]);
    delete this.polygons[index];
  }

  addPolygonsToMap() {
    this.polygons.forEach(Polygon => {
      Polygon.addTo(this.map);
    })
  }

  removePolygonsFromMap() {
    this.polygons.forEach(m => {
      this.map.removeLayer(m);
    });
    this.polygons = [];
  }

  removePolygonsPoiFromMap() {
    this.polygonsPoi.forEach(m => {
      this.map.removeLayer(m);
    });
    this.polygonsPoi = [];
  }

  resetMap() {
    this.removeMarkersFromMap();
    this.removePolygonsFromMap();
    this.removePolylinesFromMap();
  }

  disableMouseEvent(elementId: string) {
    let element = < HTMLElement > document.getElementById(elementId);
    L.DomEvent.disableClickPropagation(element);
    L.DomEvent.disableScrollPropagation(element);
  };

  centerMap(arr: any, maxZoom: number) {
        var maxlat = -Infinity,
            minlat = +Infinity,
            maxlng = -Infinity,
            minlng = +Infinity;

        if (arr.length > 0) {
            arr.forEach(rt=> {
                if(rt.coordinate.lat !=0 && rt.coordinate.lng != 0){
                    if (maxlat < rt.coordinate.lat) {
                        maxlat = rt.coordinate.lat;
                    }
                    if (minlat > rt.coordinate.lat) {
                        minlat = rt.coordinate.lat;
                    }
                    if (maxlng < rt.coordinate.lng) {
                        maxlng = rt.coordinate.lng;
                    }
                    if (minlng > rt.coordinate.lng) {
                        minlng = rt.coordinate.lng;
                    }
                }
            });
            var center1 = new L.LatLng(maxlat, maxlng),
                center2 = new L.LatLng(minlat, minlng);
            var bounds = new L.LatLngBounds(center1, center2);
            this.map.fitBounds(bounds, {padding: [50, 50], maxZoom: maxZoom});
        }
    }

    offsetMap(arr: any, zoom: number, x: number, y: number) {
        this.map.setZoom(zoom);
        var centerPoint = this.map.latLngToContainerPoint([arr.lat, arr.lng]);
        var newPoint = L.point([centerPoint.x + x, centerPoint.y + y]);
        var targetLatLng = this.map.containerPointToLatLng(newPoint);
        this.map.panTo(targetLatLng);

    }


}



// WEBPACK FOOTER //
// ./src/utils/map.service.ts